module.exports = __webpack_public_path__ + "static/media/KingArthur.86d4fd66.png";